import React, { useState } from 'react';
import styles from './OpenCloseContainer.css';

/* eslint-disable-next-line max-len */
const iconUp = 'M352 352c-8.188 0-16.38-3.125-22.62-9.375L192 205.3l-137.4 137.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25C368.4 348.9 360.2 352 352 352z';
/* eslint-disable-next-line max-len */
const iconDown = 'M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z';

export const OpenCloseContainer = ({ label, content }) => {

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.title} onClick={() => setOpen(!open)}> 
          <h3>{label}</h3>
          <div className={styles.action}  style={{ width: '30px', height: '30px' }}>
            <svg viewBox="0 0 384 512">
              <path d={!open ? iconDown : iconUp }/>
            </svg>
          </div>
        </div>
        {open && (
          <div className={styles.content}>
            <p dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        )}
      </div>
      <div className={styles.divider}></div>
    </>
  );
};